import { render } from "./8Quote.vue?vue&type=template&id=6ad13eed"
import script from "./8Quote.vue?vue&type=script&lang=js"
export * from "./8Quote.vue?vue&type=script&lang=js"

import "./8Quote.vue?vue&type=style&index=0&id=6ad13eed&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__